import type { UploadStatusMessage } from "@/hooks/use-upload-status";
import { TxType } from "@/types/transaction";

export const isDirectoryUploadFolderProgressEvent = (event: UploadStatusMessage): boolean =>
  event.type === "transaction" && event.tx_type === TxType.UPLOAD && event.fse_ids.length > 0;

export const isDriveProgressEvent = (event: UploadStatusMessage): boolean =>
  event.type === "document" ||
  isDirectoryUploadFolderProgressEvent(event) ||
  (event.tx_type === TxType.CONTRACT_FAMILY_GROUPING && event.type === "transaction");
